module.exports = __webpack_public_path__ + "img/Porto Apartment - 48 of 85.fc55f20b.jpeg";